import get from "lodash/get"

// Позволяет забрать из стора все уведомления
export const selectAllNotifications = state => {
  const storeData = get(state, `notifications.data`)
  const data = []
  // eslint-disable-next-line no-restricted-syntax, guard-for-in
  for (const items in storeData) {
    data.push(storeData[items])
  }
  data.sort((a, b) => {
    return b.sortDate - a.sortDate
  })
  return data
}
